import React, { useState } from 'react';
import Button from '../ui/Button';
import styles from './Step2Credentials.module.css';
import { motion } from 'framer-motion';
import { FaUser, FaLock } from 'react-icons/fa';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { useTranslation } from 'react-i18next';
import { HiEye, HiEyeSlash } from 'react-icons/hi2';

const stepVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};

const Step2Credentials = ({ nextStep, prevStep, setFormData, formData }) => {
  const [username, setUsername] = useState(formData.username || '');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const { notify } = useNotifications();
  
   const validatePassword = (password) => {
	  const minLength = 8;
	  const upperCase = /[A-Z]/;
	  const number = /\d/;
	  const specialChar = /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]/;

	  if (password.length < minLength) return false;
	  if (!upperCase.test(password)) return false;
	  if (!number.test(password)) return false;
	  if (!specialChar.test(password)) return false;

	  return true;
	}

  const handleNext = () => {
     try {
		const functions = getFunctions();
		const checkUserExists = httpsCallable(functions, 'checkuserexists');
		checkUserExists({ username: username }).then(async (result) => {
			const data = result.data;
			//const sanitizedMessage = data.text;
			if(data.userexists == true){
				notify("error", "Username already exists");
				return;
			}
			else {
				// ? Password strength check
				if (!validatePassword(password)) {
				  notify('error', 'Password too weak. Minimum 8 characters, 1 uppercase, 1 number, 1 special character.');
				  return;
				}
				if (password !== confirm) {
				  notify("error", 'Passwords do not match!');
				  return;
				}
				setFormData(prev => ({ ...prev, username, password }));
				nextStep();			
			}
		}).catch((error) => {
			notify("error", error.message);
	  });
    } catch (error) {
	  notify("error", error.message);
    }
  };

  return (
		<>
      <h2 className={styles.stepTitle}>Create Your Credentials</h2>

      {/* Username */}
      <div className={styles.inputGroup}>
        <label htmlFor="username">
          <FaUser className={styles.icon} />
          Username
        </label>
        <input
          type="text"
          id="username"
          placeholder="Choose a username"
          className={styles.inputField}
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
        />
        <small className={styles.helperText}>
          This will be your public debate handle.
        </small>
      </div>

      {/* Password */}
      <div className={styles.inputGroup}>
        <label htmlFor="password">
          <FaLock className={styles.icon} />
          Password
        </label>
		<div className={styles.passwordWrapper}>
        <input
          type={showPassword ? "text" : "password"}
          id="password"
          placeholder="Enter a secure password"
          className={styles.inputField}
          value={password}
          onChange={e => setPassword(e.target.value)}
          required/>
			<Button  type="button"  className={styles.eyeBtn}  onClick={() => setShowPassword(!showPassword)}>
			  {showPassword ? <HiEyeSlash /> : <HiEye />}
			</Button>
		  </div>
        <small className={styles.helperText}>
          Must be at least 8 characters and include a number.
        </small>
      </div>

      {/* Confirm Password */}
      <div className={styles.inputGroup}>
        <label htmlFor="confirm">
          <FaLock className={styles.icon} />
          Confirm Password
        </label>
		<div className={styles.passwordWrapper}>
        <input
          type={showPassword ? "text" : "password"}
          id="confirm"
          placeholder="Confirm your password"
          className={styles.inputField}
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          required/>
			<Button  type="button"  className={styles.eyeBtn}  onClick={() => setShowPassword(!showPassword)}>
			  {showPassword ? <HiEyeSlash /> : <HiEye />}
			</Button>
		  </div>
        <small className={styles.helperText}>
          Re-enter the same password to confirm.
        </small>
      </div>

      <div className={styles.navbuts}>
        <Button variant="secondary" className={styles.prevButton} onClick={prevStep}>Back</Button>
        <Button variant="primary" className={styles.nextButton} onClick={handleNext}>Next</Button>
      </div>
	  </>
  );
};

export default Step2Credentials;

